import bannerBg from '../assets/img/page-banner.webp';
import Approch from '../components/Approch';
import Footer2 from '../components/Footer2';
import Header3 from '../components/Header3';
import PageBanner from '../components/PageBanner';
import Sponsors2 from '../components/Sponsors2';
import Timeline from '../components/Timeline';
import Process2 from '../components/Process2';

function About() {
    return (
        <>
            <Header3 />
            <PageBanner bannerBg={bannerBg} currentPage="About Us" heading="About Us" />
            <Process2 />
            <Timeline />
            <Approch />
            <Sponsors2 />
            <Footer2 />
        </>
    );
}

export default About;
